/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Not_Understood_DescInputs */

const en_ui_filter_not_understood_desc = /** @type {(inputs: Ui_Filter_Not_Understood_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a sport, a date, a distance, a duration or a "name in quotes"`)
};

const de_ui_filter_not_understood_desc = /** @type {(inputs: Ui_Filter_Not_Understood_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probier eine Sportart, ein Datum, eine Strecke, eine Dauer oder einen „Namen in Anführungszeichen“`)
};

/**
* | output |
* | --- |
* | "Try a sport, a date, a distance, a duration or a \"name in quotes\"" |
*
* @param {Ui_Filter_Not_Understood_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_not_understood_desc = /** @type {((inputs?: Ui_Filter_Not_Understood_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Not_Understood_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_not_understood_desc(inputs)
	return de_ui_filter_not_understood_desc(inputs)
});